export function IconEEICardMobile() {
  return (
    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.208984" width="54" height="54" rx="6" fill="white" fillOpacity="0.2" />
      <rect x="25" y="13.209" width="4" height="28" fill="white" fillOpacity="0.5" />
      <rect
        x="37.1118"
        y="14.209"
        width="4.01688"
        height="28.6594"
        transform="rotate(25 37.1118 14.209)"
        fill="white"
      />
    </svg>
  )
}
